export enum StationType {
  Sale = 'Sale',
  Validator = 'Validator',
}

export enum StationStatus {
  Ready = 'Ready',
  InUse = 'InUse',
  Sleeping = 'Sleeping',  // will remove after discussion
  Resting = 'Resting',
  Disabled = 'Disabled',
  Disconnected = 'Disconnected',
  Diagnostic = 'Diagnostic',
  AssistanceNeeded = 'AssistanceNeeded',
  ShopperAssistance = 'ShopperAssistance',
  Maintenance = 'Maintenance',
  RegisteredAwaitingConnection = 'RegisteredAwaitingConnection',
}

export interface StatusDataType {
  name: string;
  text: string;
  textColor: string;
  color: string;
}

export interface PosDeviceAssociatedDto {
  posDeviceIdentifier?: string;
  stationId: number;

  stationName: string;

  stationPermanentId: string;

  posApiKey: string;
}
export interface StationDeviceAssociationResponse {
  stationIdentifier: string; 
  
  apiKey: string | null;
  url: string | null;
}
